var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.25C3 2.73122 4.23122 1.5 5.75 1.5C7.26878 1.5 8.5 2.73122 8.5 4.25C8.5 5.76878 7.26878 7 5.75 7C4.23122 7 3 5.76878 3 4.25Z",
    fill: "#00BBF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75C9.5 4.50736 10.5074 3.5 11.75 3.5C12.9926 3.5 14 4.50736 14 5.75C14 6.99264 12.9926 8 11.75 8C10.5074 8 9.5 6.99264 9.5 5.75Z",
    fill: "#00BBF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.75C1 10.1266 3.12665 8 5.75 8C8.37335 8 10.5 10.1266 10.5 12.75V12.7517C10.5 12.7782 10.4998 12.8049 10.4993 12.8313C10.4964 13.0036 10.405 13.1623 10.2573 13.2512C8.94047 14.0441 7.39771 14.5 5.75 14.5C4.10229 14.5 2.55953 14.0441 1.24271 13.2512C1.09504 13.1623 1.00358 13.0036 1.00068 12.8313C1.00023 12.8043 1 12.7772 1 12.75Z",
    fill: "#00BBF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 12.7521C11.4999 12.7841 11.4996 12.8163 11.4991 12.8481C11.4953 13.0739 11.4408 13.2918 11.3438 13.488C11.4782 13.496 11.6136 13.5 11.7499 13.5C12.8137 13.5 13.8214 13.2535 14.7176 12.8142C14.8823 12.7334 14.9896 12.569 14.9971 12.3858C14.999 12.3407 14.9999 12.2955 14.9999 12.25C14.9999 10.4551 13.5448 9 11.7499 9C11.2523 9 10.7808 9.11184 10.3591 9.31176C11.0756 10.2708 11.4999 11.4608 11.4999 12.75V12.7521Z",
    fill: "#00BBF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.d3fd9ec8d57123c5ab9e962dc0eac5fd.svg";
export { ForwardRef as ReactComponent };